module.exports = __webpack_public_path__ + "img/vip1.c9f78765.png";